(function () {
  'use strict';

  var B2B = window.NAAZME_B2B;
  if (!B2B) return;

  // -- Price formatting -------------------------------------------------------

  var CURRENCY_SYMBOLS = { AED: 'AED', USD: 'USD', INR: '₹' };

  function aedToDisplay(aedAmount) {
    var currency = B2B.currency || 'AED';
    var rate = (B2B.rates && B2B.rates[currency]) || 1;
    var converted = (parseFloat(aedAmount) * rate).toFixed(2);
    var sym = CURRENCY_SYMBOLS[currency] || currency;
    // INR uses symbol prefix, others suffix
    return currency === 'INR' ? sym + ' ' + converted : converted + ' ' + sym;
  }

  function naazmeAed(cost, multiplier) {
    cost = parseFloat(cost);
    if (!cost || isNaN(cost)) return null;
    return (cost <= 5 ? cost * 2 : cost * multiplier).toFixed(2);
  }

  // Write formatted price into el, preserving .sr-only accessibility label.
  function setPriceEl(el, formatted) {
    var srOnly = el.querySelector('.sr-only');
    if (srOnly) {
      el.innerHTML = srOnly.outerHTML + formatted;
    } else {
      var money = el.querySelector('.money');
      if (money) {
        money.textContent = formatted;
      } else {
        el.textContent = formatted;
      }
    }
    el.dataset.naazmeB2b = '1';
  }

  // -- Product page: exact cost lookup (main product price only) --------------

  function getCurrentVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var inp = form.querySelector('input[name="id"]');
      if (inp) return inp.value;
    }
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function updateMainProductPrice(variantId) {
    if (!variantId) return;
    var cost = B2B.costs[variantId];
    if (!cost) return;
    var aed = naazmeAed(cost, B2B.multiplier);
    if (!aed) return;
    var formatted = aedToDisplay(aed);

    // Impact theme uses price-list--lg for the main product price.
    var selectors = [
      'price-list.price-list--lg sale-price',
      'price-list.price-list--lg regular-price',
      '.price__sale .price-item--sale',
      '.price__regular .price-item--regular',
      '.price-item--sale',
      '.price-item--regular',
      '[data-product-price]',
      '.price .money',
    ];
    var els = [];
    for (var i = 0; i < selectors.length; i++) {
      var found = document.querySelectorAll(selectors[i]);
      if (found.length) { els = found; break; }
    }
    els.forEach(function (el) { setPriceEl(el, formatted); });
  }

  function onProductPage() {
    var variantId = getCurrentVariantId() || Object.keys(B2B.costs)[0];
    updateMainProductPrice(variantId);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') updateMainProductPrice(e.target.value);
    });
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) updateMainProductPrice(String(e.detail.variant.id));
    });
  }

  // -- Ratio-based replacement for card prices --------------------------------
  // All public prices = cost × 1.8 (set by sync scripts).
  // B2B AED price = public × (multiplier / 1.8), then converted to display currency.

  var CARD_SELS = [
    'sale-price',
    'regular-price',
    '.price-item--sale',
    '.price-item--regular',
    '[data-product-price]',
  ];

  function applyRatioToEl(el) {
    if (el.dataset.naazmeB2b) return;
    var text = el.textContent.trim();
    var match = text.match(/(\d+\.?\d*)/);
    if (!match) return;
    var pub = parseFloat(match[1]);
    if (!pub) return;
    // pub is already in AED (store base currency)
    var b2bAed = (pub * (B2B.multiplier / 1.8)).toFixed(2);
    setPriceEl(el, aedToDisplay(b2bAed));
  }

  function applyRatioToAll() {
    CARD_SELS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(applyRatioToEl);
    });
  }

  // -- Init ------------------------------------------------------------------

  function init() {
    if (B2B.isClient && B2B.multiplier) {
      if (Object.keys(B2B.costs).length) onProductPage();
      applyRatioToAll();

      // Watch for dynamically injected content (recommendation apps, lazy sections)
      var _t;
      new MutationObserver(function (mutations) {
        if (mutations.some(function (m) { return m.addedNodes.length; })) {
          clearTimeout(_t);
          _t = setTimeout(applyRatioToAll, 200);
        }
      }).observe(document.body, { childList: true, subtree: true });

    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
